import { useMutation } from '@apollo/client';
import { MessageBar } from '@repo/ui/components';
import { ICalculation } from 'next-common';
import { useState } from 'react';
import { TMessageBarSeverity } from 'types';
import { IValidationToastNotification, updateCalculationMutationParsed, useEmployee } from '../../common';
import { getOriginalNominalInterest } from '../../utils';
import { CommentModal } from '../sales/sales-common/Comments';
import { getNominalInterest, getRequestedNominalInterest } from '../sales/sales-common/FinancingDialog';

export interface IInterestWarning extends IValidationToastNotification {
  offer: ICalculation;
}

export const InterestWarning = (props: IInterestWarning) => {
  const [showModal, setShowModal] = useState(false);
  const [updateCalculationMutation] = useMutation(updateCalculationMutationParsed);
  const employee = useEmployee();
  const originalInterest = getOriginalNominalInterest(props.offer);
  const updatedInterest =
    getRequestedNominalInterest(props.offer.financing) || getNominalInterest(props.offer.financing) || 0;
  const [isOpen, setIsOpen] = useState(true);

  const saveComment = async (newComment: string) => {
    try {
      await updateCalculationMutation({
        variables: {
          calculationId: props.offer?.id,
          input: {
            comments: [
              {
                text: newComment,
                userId: employee?.employeeId,
              },
            ],
          },
        },
      });
    } catch (error) {
      // tslint:disable-next-line:no-console
      console.error(error);
    }
  };
  const onSubmitComment = async (value: string) => {
    await saveComment(value);
    setIsOpen(false);
    setShowModal(false);
  };

  if (!isOpen) return null;

  return (
    <>
      <MessageBar severity={TMessageBarSeverity.WARNING} dismissible onClose={props?.onClose}>
        <h4 className="text-lg/[175%]">Rente er endret</h4>
        <p className="text-lg/[170%] font-semibold">
          Du har endret renten fra {originalInterest}% til {updatedInterest}% og må derfor legge inn en kommentar til
          DNB Finans AS. Dette kan gjøres her:
        </p>
        <a onClick={() => setShowModal(true)} className="text-black text-lg/[170%] font-semibold">
          &nbsp;"Kommentar til DNB Finans AS"
        </a>
      </MessageBar>
      <CommentModal
        isOpen={showModal}
        onSubmit={onSubmitComment}
        close={() => setShowModal(false)}
        title={'Kommentar til DNB Finans AS'}
      />
    </>
  );
};
